import { experiencesData } from './ExperienceData';

import { useRef } from 'react';

import './Experiences.scss';

import { motion, useScroll, useTransform } from 'framer-motion';

const ExperiencesUI = () => {
  const datas = experiencesData();

  const containerRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: containerRef,

    offset: ['start center', 'end end']
  });

  return (
    <motion.div className="ex-contents" ref={containerRef}>
      {datas.map((data, index) => (
        <ExperienceItem key={index} data={data} index={index} scrollProgress={scrollYProgress} />
      ))}
    </motion.div>
  );
};

const ExperienceItem = ({ data, index, scrollProgress }) => {
  const itemRef = useRef(null);

  const scale = useTransform(
    scrollProgress,
    [index * 0.1, index * 0.1 + 0.1, index * 0.1 + 0.7],
    [1.8, 0.9, 0.7]
  );

  const y = useTransform(scrollProgress, [(index + 1) * 0.2, (index + 0.2) * 0.2], [index * -120, 0]); // Adjust vertical movement

  // const opacity = useTransform(scrollProgress, [index * 0.2, (index + 0.2) * 0.2], [0, 1]); // Fade in

  return (
    <div className="sticky top-0">
      <motion.div ref={itemRef} className="ex-data" aria-label="Experience data" style={{ scale, y }}>
        <div className="top">
          <div className="left">
            <h3 aria-label={data.companyName}>
              <a href={data.companyUrl} target="_blank" rel="noopener noreferrer">
                {data.companyName}
              </a>
            </h3>

            <h5 aria-label={data.role}>{data.role}</h5>
          </div>

          <div className="right">
            <p aria-label={data.periods}>{data.periods}</p>
          </div>
        </div>

        <div className="body">
          <ul>
            {data.descriptions.map((des, i) => (
              <li aria-label={des} key={i}>
                {des}
              </li>
            ))}
          </ul>

          {data.projects.length > 0 && data.projects[0] && (
            <p className="projects">
              <strong>Projects: </strong>

              {data.projects.map(
                (project, i) =>
                  project &&
                  data.projectsName[i] && (
                    <span key={i}>
                      {i > 0 && ', '}

                      <a href={project} target="_blank" rel="noopener noreferrer">
                        {data.projectsName[i]}
                      </a>
                    </span>
                  )
              )}
            </p>
          )}
        </div>
      </motion.div>
    </div>
  );
};

export default ExperiencesUI;
